export default function AboutMission() {
  const values = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Our Mission',
      description: 'To provide exceptional, personalized homecare services that enhance quality of life, promote independence, and deliver peace of mind to clients and their families.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Our Vision',
      description: 'To be the most trusted and respected homecare provider in our community, setting the standard for compassionate, professional care that transforms lives.'
    },
    {
      icon: 'ri-star-line',
      title: 'Core Values',
      description: 'Compassion, Integrity, Excellence, Respect, and Reliability guide everything we do. We treat every client as family and every interaction as an opportunity to make a difference.'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Mission, Vision & Values
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The principles that guide our commitment to exceptional care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#5C4F8A] rounded-xl mb-6">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
